<template>
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4">
					<div class="animate__animated animate__fadeIn">
						<div class="position-relative text-center text-white mb-5">
							<img src="@/assets/img/logo.png" class="w-50 mb-3" />
							<h4 class="mb-0">
								<strong>ЗАЧИСТКА ПОДЗЕМЕЛЬЯ</strong>
							</h4>
						</div>
						<div class="card">
							<div class="card-body text-center">
								<div class="d-grid gap-2">
									<div class="alert alert-warning mb-0 text-center">Для запуска игрового раунда необходимо авторизоваться</div>
									<div @click="redirectToAuth()" class="btn btn-lg btn-primary d-block">Авторизоваться</div>
									<router-link :to="{path: '/'}" class="btn btn-lg btn-secondary mt-3">Назад</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Авторизация | TankOn2'});
	},
	data: () => ({
		
    }),
    methods: {
		redirectToAuth(){
			const redirectUri = window.location.origin;
			const authUrl = 'https://id.bylex.su/login-out?' + new URLSearchParams({
				redirect: redirectUri,
			});
			window.location.href = authUrl;
		},
	},
	mounted(){
		//window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		//window.scrollTo(0, 0);
		next();
	},
	components: {},
}
</script>